import bestSubSequence from './lcs';
export default function (a, b, compareFunc) {
    if (compareFunc === void 0) { compareFunc = function (ia, ib) { return ia === ib; }; }
    var ret = [];
    bestSubSequence(a, b, compareFunc, function (type, oldArr, oldStart, oldEnd) {
        if (type === 'same') {
            for (var i = oldStart; i < oldEnd; ++i) {
                ret.push(oldArr[i]);
            }
        }
    });
    return ret;
}
